import React from 'react';
import styled from 'styled-components/macro';
import { useTranslate } from '../../contexts/languageContext';
import Logo from '../../containers/Logo';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import { getUrl } from '../../utils';
import { usePage } from '../../contexts/pageContext';
import constantes from '../../resources/constantes.json';
import { Link } from 'react-router-dom';
import { responsive } from '../../resources/constantes.json';
import { useEleccion } from '../../contexts/eleccionContext';
import { fmt } from '../../utils';
import { themes } from '../../styles/themes';
import { getCandidatosImg } from '../../utils/getCandidatos';
import theme from 'echarts/src/theme/dark';
const FilaTablaTerritorios = props => {
  const t = useTranslate();
  const nomenclator = useNomenclator();
  const pageState = usePage();
  const elecOptions = useEleccion();
  const { urlInfo } = pageState;
  const { idHistorico } = urlInfo;
  const esHistorico = idHistorico != null;
  const codpar = props.territorio.codpar
  const codparPostition = Number(codpar) - 1
  const isEmpate = props.territorio.hayEmpate === '1'
  const ColorPartido =
    props.hayGanadores ?
      !isEmpate ?
        nomenclator.partidos[codparPostition].color
        : themes.color.empate
      : themes.color.sinInfo
  //const LogoPartido = nomenclator.partidos[codparPostition].codpar;
  const NombrePar = nomenclator.partidos[codparPostition].nombre;
  const eleccion = elecOptions.idEleccion;

  const { codcan, nomcan, apecan, nomcan2, apecan2 } = props.territorio.cantotabla
  const nomPresi = nomcan + ' ' + apecan
  const nomVice = nomcan2 + ' ' + apecan2
  const { imgPresi, imgVice } = getCandidatosImg(nomenclator, codcan, codpar)

  const { pvot, vot } = props.territorio
  return (
    <ContainerFila color={ColorPartido}>
      <Territorio>
        {!esHistorico ? (
          <SLink
            to={getUrl({
              id: nomenclator.ambitos[eleccion].find(
                y => y.c === props.territorio.amb
              ).i,
              eleccion,
              nomenclator,
              page: constantes.nombreEleccion[eleccion],
            })}
          >
            {props.territorio.nombre}
          </SLink>
        ) : (
          <p className="dataTitle" css="color: #222;"> {props.territorio.nombre}</p>
        )}
      </Territorio>
      <ContainerSegundaFila>
        <PartidoMasVotado>
          <p className="dataTitle pmv">{t('partidoMasVotado')}</p>
          <DatosPartido>
            {props.hayGanadores && !isEmpate ? (
              <>
                {/*<StyledLogo codpar={isEmpate ? '-1' : LogoPartido} />*/}
                <FotosContainer>
                  <Foto
                    src={`${imgPresi}.webp`}
                    alt="Imagen candidato" />
                  <Foto
                    src={`${imgVice}.webp`}
                    alt="Imagen candidato" />
                </FotosContainer>
                <NombresContainer>
                  <NombreCandidato>{nomPresi}</NombreCandidato>
                  <NombreCandidato>{nomVice}</NombreCandidato>
                  <NombrePartido>{isEmpate ? t('empate') : NombrePar}</NombrePartido>
                  <NumPvotVot>{pvot}
                    <NumVot>
                      {' (' + fmt(vot) + ')'}
                    </NumVot>
                  </NumPvotVot>

                </NombresContainer>
              </>
            ) : isEmpate && props.hayGanadores
						? ( <NombreCandidato>{t('empate')}</NombreCandidato> ) 
						: (<NombreCandidato>{t('sinInformacion')}</NombreCandidato>)
						}
          </DatosPartido>
        </PartidoMasVotado>
        <DatosNumericos>
          <MesasInformadas>
            <p className="dataTitle">Mesas informadas</p>
            <p className="dataPorc">{props.territorio.pmesesc}</p>
            <p className="dataABS">{fmt(props.territorio.mesesc)}</p>
          </MesasInformadas>
          <Votantes>
            <p className="dataTitle">Votantes</p>
            <p className="dataPorc">{props.territorio.pvotant}</p>
            <p className="dataABS">{fmt(props.territorio.votant)}</p>
          </Votantes>

        </DatosNumericos>
      </ContainerSegundaFila>
    </ContainerFila>
  );
};

const StyledLogo = styled(Logo)`
  flex: 0 0 auto;
  width: 100%;
  background: grey;
	height: auto;
`;

const Foto = styled.img`
  font-size: 10px;
  max-width: 50px;
  height: 50px;
`

const FotosContainer = styled.div`
  display:flex;
  gap: 10px;

  
  @media   
  screen and (max-width: 550px){
    width: 30%;
  }
`
const NombresContainer = styled.div`
  display:flex;
  flex-direction:column;
  gap: 5px;

  @media 
  screen and (max-width: 550px){
    width: 70%;
  }
`


const NombreCandidato = styled.div`
  font-weight: 700;
  font-size: 16px;
`
const NombrePartido = styled.div`
  font-weight: 300;
  font-size: 14px;
`;
const NumPvotVot = styled.div`
  font-weight: 700;
  font-size: 14px;
`;

const NumVot = styled.span`
  font-weight: 400;
`;


const DatosNumericos = styled.div`
  width: 38%;
  display:flex;

  @media 
  screen and (max-width: 550px){
    width: 100%;
  }
`

const ContainerFila = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 30px;
  background: #fff;
  width: 97%;
  border: 1px solid #d8d8d8;
  border-radius: 3px;
  flex-direction: column;
  border-left:5px solid ${({ color }) => color}
`;

const ContainerSegundaFila = styled.div`
  display: flex;
  width: 98%;
  margin: auto;
  flex-wrap: wrap;
  gap: 10px;
  .dataABS{
    font-weight: 100;
    font-size:1.6rem;
  }
  .dataPorc{
    font-weight: 700;
    font-size:2.4rem;
  }
  .dataTitle{
    font-weight:700;
  }
`;

const Territorio = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
  align-items: center;
  flex: 0 0 95%;
  box-sizing: border-box;
`;

const PartidoMasVotado = styled.div`
  width: 58%;

  @media screen and (max-width: ${responsive.tablet}px) {
    width: 58%;
  }
  @media 
  screen and (max-width: 550px){
    width: 100%;
  }
`;

const MesasInformadas = styled.div`
  width: 58%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const Votantes = styled.div`
  width: 42%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const DatosPartido = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: max(2%, 20px);
`;

const SLink = styled(Link)`
  text-decoration: underline;
  color: #222;
  font-weight: 700;
  font-size: 14px;
`;
export default FilaTablaTerritorios;
